import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punecabbooking() {



    const cardData = {

keyword: "Pune Cab Booking",

headingDescription:
    "Rising Cab Service offers fast, safe, and reliable Pune Cab Booking for local city rides, airport transfers, railway station pickups, corporate travel, and outstation journeys. We provide a wide range of vehicles including Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury cars with professional and verified drivers. With 24/7 availability, easy booking options, doorstep pickup across Pune, and transparent pricing, we ensure a smooth, comfortable, and hassle-free travel experience for every passenger.",

topPlaces: [
 
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, waterfalls, and cool climate. Attractions like Arthur’s Seat, Venna Lake, and Elephant’s Head Point make it a top choice for family and couple trips from Pune."
    },
    {
        title: "Mumbai City",
        description:
            "Mumbai is a major metro destination from Pune known for Gateway of India, Marine Drive, Juhu Beach, and corporate hubs. It is widely used for business travel, airport transfers, and weekend leisure trips."
    },
    {
        title: "Bhimashankar Jyotirlinga",
        description:
            "Bhimashankar is a sacred Jyotirlinga temple located in the Sahyadri hills surrounded by dense forest. It is a popular spiritual and trekking destination for pilgrims and nature lovers traveling from Pune."
    },
    {
        title: "Lavasa",
        description:
            "Lavasa is a planned hill city near Pune known for lakeside promenades, boating, colorful architecture, and peaceful surroundings. It is a short and relaxing cab trip ideal for weekend getaways."
    },
    {
        title: "Goa Beaches",
        description:
            "Goa is a long-distance holiday destination from Pune famous for beaches, nightlife, water sports, and scenic coastal drives. It is a top choice for group trips and vacation cab bookings."
    },
       {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are the most popular weekend destinations from Pune, known for misty hills, waterfalls, green valleys, and viewpoints like Tiger Point and Bhushi Dam. These twin hill stations are ideal for short trips, monsoon drives, and family outings."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba, attracting devotees from across India. Visitors travel for Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi, making it one of the most frequently booked cab routes from Pune."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a spiritual and cultural hub known for Trimbakeshwar Jyotirlinga, Panchavati temples, and the Godavari river ghats. It also offers vineyard tours and scenic drives, making it a balanced destination for both religious and leisure cab travel."
    },
    {
        title: "Aurangabad Heritage Sites",
        description:
            "Aurangabad is known for UNESCO World Heritage Sites like Ajanta Caves and Ellora Caves along with Bibi Ka Maqbara. It is a popular long tour destination from Pune for history and culture lovers."
    },
    {
        title: "Tamhini Ghat & Mulshi",
        description:
            "Tamhini Ghat and Mulshi are scenic monsoon destinations near Pune known for waterfalls, misty valleys, and dam views. They are popular short cab routes for nature lovers and photography trips."
    }
],



services: [
{
name: "Pune Cab Booking",
description: "Rising Cab Service offers Pune Cab Booking with safe, reliable, and comfortable transportation for local rides, airport transfers, and outstation journeys. Enjoy 24x7 availability, professional drivers, and clean AC vehicles."
},
{
name: "Online Cab Booking Pune",
description: "Book Online Cab Booking Pune instantly with easy reservation, transparent pricing, and multiple vehicle options including sedan, SUV, and Innova for all travel needs."
},
{
name: "Cab Booking App Pune",
description: "Our Cab Booking App Pune service provides quick ride booking with real-time availability, instant confirmation, and smooth user experience for daily travel."
},
{
name: "Instant Cab Booking Pune",
description: "Rising Cab Service ensures Instant Cab Booking Pune for urgent travel needs with fast pickup, verified drivers, and reliable vehicles across Pune."
},
{
name: "Book Cab Pune",
description: "Book Cab Pune easily for city travel, airport transfers, and long-distance trips with flexible options and affordable pricing."
},
{
name: "Pune Cab Reservation",
description: "Our Pune Cab Reservation service allows advance booking for planned journeys, ensuring guaranteed cab availability for airport and outstation travel."
},
{
name: "Taxi Booking Pune Online",
description: "Rising Cab Service provides Taxi Booking Pune Online with secure booking system, budget-friendly fares, and 24x7 customer support."
},
{
name: "Local Cab Booking Pune",
description: "Book Local Cab Booking Pune for daily commuting, office travel, shopping, and short-distance city rides with quick response time."
},
{
name: "Outstation Cab Booking Pune",
description: "Our Outstation Cab Booking Pune service offers safe and comfortable long-distance travel to Mumbai, Goa, Nashik, Shirdi, and other major destinations."
},
{
name: "Cab Hire Pune",
description: "Rising Cab Service offers Cab Hire Pune for flexible travel needs including hourly rentals, full-day packages, and intercity trips."
},
{
name: "Best Cab Booking Pune",
description: "Book Best Cab Booking Pune for reliable service, punctual pickups, professional drivers, and clean vehicles across all routes."
},
{
name: "Cab Booking Near Me Pune",
description: "Our Cab Booking Near Me Pune service helps you quickly find nearby available cabs for instant and convenient pickup."
},
{
name: "Affordable Cab Booking Pune",
description: "Rising Cab Service provides Affordable Cab Booking Pune with budget-friendly fares while maintaining safety and comfort."
},
{
name: "Pune Cab Hire Service",
description: "Book Pune Cab Hire Service for personal, family, and corporate travel with flexible packages and experienced drivers."
},
{
name: "Quick Cab Booking Pune",
description: "Our Quick Cab Booking Pune service ensures instant ride confirmation and fast pickup for urgent travel requirements."
},
{
name: "Outstation Cabs Pune",
description: "Rising Cab Service offers Outstation Cabs Pune for safe and comfortable long-distance journeys with experienced drivers."
},
{
name: "Cheapest Cab Service in Pune",
description: "Book Cheapest Cab Service in Pune for economical travel options without compromising safety and reliability."
},
{
name: "Pune to Mumbai Cab Service",
description: "Our Pune to Mumbai Cab Service provides comfortable highway travel with one-way and round-trip options for business and leisure trips."
},
{
name: "Taxi Services in Pune",
description: "Rising Cab Service offers Taxi Services in Pune for local, airport, and outstation travel with 24x7 availability."
},
{
name: "24x7 Cab Booking Pune",
description: "Book 24x7 Cab Booking Pune anytime for emergency rides, airport transfers, and late-night travel with reliable service."
}
],

tableData: [
["Pune Cab Booking","Online Cab Booking Pune"],
["Cab Booking App Pune","Instant Cab Booking Pune"],
["Book Cab Pune","Pune Cab Reservation"],
["Taxi Booking Pune Online","Local Cab Booking Pune"],
["Outstation Cab Booking Pune","Cab Hire Pune"],
["Best Cab Booking Pune","Cab Booking Near Me Pune"],
["Affordable Cab Booking Pune","Pune Cab Hire Service"],
["Quick Cab Booking Pune","Outstation Cabs Pune"],
["Cheapest Cab Service in Pune","Pune to Mumbai Cab Service"],
["Taxi Services in Pune","24x7 Cab Booking Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Fast and Easy Pune Cab Booking",
        WhyChoosedescription: "Rising Cab Service offers quick cab booking services in Pune for local travel, airport transfers, outstation trips, corporate travel, and sightseeing tours."
    },
    {
        WhyChooseheading: "Taxi Booking Available 24/7",
        WhyChoosedescription: "Customers can reserve cabs anytime for early morning airport drops, late-night pickups, business travel, family outings, and emergency transportation."
    },
    {
        WhyChooseheading: "Local and Outstation Travel Solutions",
        WhyChoosedescription: "Whether you need a city taxi or an outstation cab to Mumbai, Shirdi, Nashik, Goa, Mahabaleshwar, Lonavala, or other destinations, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Large Fleet of Comfortable Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to your travel requirements."
    },
    {
        WhyChooseheading: "Pickup from All Major Pune Locations",
        WhyChoosedescription: "Cab booking services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding areas."
    },
    {
        WhyChooseheading: "Ideal for Family and Corporate Travel",
        WhyChoosedescription: "Our cab booking service is suitable for family vacations, employee transportation, business meetings, educational trips, and personal travel."
    },
    {
        WhyChooseheading: "Clean Vehicles and Professional Drivers",
        WhyChoosedescription: "Every trip is supported by experienced drivers and well-maintained vehicles to ensure a safe and comfortable journey."
    },
    {
        WhyChooseheading: "Trusted Transportation Partner in Pune",
        WhyChoosedescription: "Rising Cab Service is preferred by local residents, tourists, students, senior citizens, and corporate clients for dependable travel solutions."
    }
]
};

const faqData = [
    {
        question: "What is Pune Cab Booking Service?",
        answer: "Pune Cab Booking Service allows customers to reserve taxis for local travel, airport transfers, railway station pickups, outstation trips, sightseeing tours, and corporate transportation."
    },
    {
        question: "Can I book a cab for Pune Airport pickup and drop?",
        answer: "Yes, airport transfer services are available for Pune Airport and nearby locations."
    },
    {
        question: "Are outstation cab bookings available from Pune?",
        answer: "Yes, customers can book cabs for destinations across Maharashtra and various cities throughout India."
    },
    {
        question: "Which vehicle options are available for booking?",
        answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Can I reserve a cab for corporate travel?",
        answer: "Yes, businesses and professionals regularly use our services for meetings, employee transportation, and official travel."
    },
    {
        question: "Are railway station pickup and drop services available?",
        answer: "Yes, transportation services are available for Pune Railway Station and nearby railway terminals."
    },
    {
        question: "Can families book larger vehicles for tours and events?",
        answer: "Yes, Tempo Travellers and larger group vehicles are available for family functions, sightseeing tours, and group travel."
    },
    {
        question: "Do you provide advance cab booking facilities?",
        answer: "Yes, advance reservations are available for planned travel, holidays, tours, and special occasions."
    },
    {
        question: "Is cab booking available throughout Pune and PCMC?",
        answer: "Yes, services are available across Pune city and Pimpri Chinchwad including all major residential and commercial areas."
    },
    {
        question: "How can I complete a Pune Cab Booking?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Shinde",
        feedback:
            "Arranging a cab in Pune was simple and convenient. The vehicle arrived on schedule, the ride was comfortable, and the entire experience was handled professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Patil",
        feedback:
            "For both local and outstation travel, Rising Cab Service has consistently provided dependable transportation. The vehicles are clean, and every journey has been smooth and enjoyable.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune Cab Booking Service",
"image": "https://www.risingcabservice.com/assets/images/pune-cab-booking.jpg",
"description": "Book Pune Cab Booking Service with Rising Cab Service for instant, reliable, and affordable taxi booking. Get 24x7 local, airport, and outstation cab service with AC sedans, SUVs, and Innova cars.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-cab-booking"
}
};








    return (
        <div>
<Helmet>
  <title>Pune Cab Booking | Instant Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune Cab Booking instantly with Rising Cab Service. Get affordable 24x7 local, airport, and outstation taxi booking with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune cab booking, online cab booking pune, cab booking app pune, instant cab booking pune, book cab pune, pune cab reservation, taxi booking pune online, local cab booking pune, outstation cab booking pune, cab hire pune, best cab booking pune, cab booking near me pune, affordable cab booking pune, pune cab hire service, quick cab booking pune, Outstation Cabs Pune, Cheapest cab service in pune, Pune to mumbai cab service, Taxi Services in Pune, Pune Cab Booking, Cab Booking Service Pune, Online Cab Booking Pune, Best Cab Booking in Pune, 24x7 Cab Booking Pune, Pune Taxi Booking Service, Local Cab Booking Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punecabbooking;